//import '@babel/polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import router from './router'
import VideoBackground from 'vue-responsive-video-background-player'
// import Vue from "vue";
import VueParticles from "vue-particles";

Vue.use(VueParticles);
Vue.use(Vuetify)
Vue.component('video-background', VideoBackground);



Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
